import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiDollGeneratorConfig } from '@/data/landingConfig/landingAiDollGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiDollGenerator } from './schemaObject';

interface Props {}
const AiDollGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiDollGenerator} />
			<LandingTemplate
				data={landingAiDollGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelCartoonGenerator()}
			/>
		</>
	);
};

export default AiDollGenerator;
